<template>
    <div>
    <div v-if="$page.props.impersonating"
         class="flex items-center justify-between px-6 py-2 bg-amber-400 text-amber-900 text-sm font-medium">
        <span>Ви переглядаєте кабінет як інший користувач</span>
        <Link :href="$route('users.stop-impersonating')" method="post" as="button"
              class="ml-4 px-3 py-1 rounded bg-amber-900 text-white btn-booking text-xs hover:bg-amber-800 transition">
            Повернутись до адміна
        </Link>
    </div>
    <header class="header">
        <div class="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8">
            <nav class="container mx-auto xl:flex xl:justify-between xl:items-center">
                <div class="flex items-center justify-between">
                    <Link :href="$route('index')"><img src="/images/logo.svg" width="200" alt="Хвиля"></Link>
                    <div class="flex items-center justify-between">
                        <div class="mr-8 mobile-cart">
                            <Link :href="$route('index.cart')" class="flex text-white">
                                <CartIcon :count="cartCount"/>
                            </Link>
                        </div>
                        <div @click="toggleNav" class="flex xl:hidden">
                            <button type="button"
                                    class="text-gray-100 hover:text-gray-400 focus:outline-none focus:text-gray-400">
                                <div class="w-5 h-1 bg-white mb-1"/>
                                <div class="w-5 h-1 bg-white mb-1"/>
                                <div class="w-5 h-1 bg-white"/>
                            </button>
                        </div>
                    </div>
                </div>
                <ul :class="showMenu ? 'flex' : 'hidden'"
                    class="flex-col text-right mt-8 space-y-4 xl:flex xl:space-y-0 xl:flex-row xl:items-center xl:space-x-10 xl:mt-0">
                    <li v-for="item in menu" :key="item.routeName">
                        <Link class="text-white text-lg hover:underline" :href="$route(item.routeName)">
                            {{ item.name }}
                        </Link>
                    </li>
                    <li>
                        <Link
                            v-if="$page.props.auth.user"
                            class="text-white text-lg hover:underline"
                            :href="$route('logout')"
                            method="delete"
                            as="button"
                        >
                            Вийти
                        </Link>
                    </li>
                </ul>
                <div class="desktop-cart">
                    <Link :href="$route('index.cart')" class="flex text-white">
                        <CartIcon :count="cartCount"/>
                    </Link>
                </div>
            </nav>
        </div>
    </header>
    </div>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3'
import CartIcon from "@/Shared/CartIcon"
import {mainMenu} from "@/Constants/menu"

export default {
    components: {
        CartIcon,
        Link
    },
    props: {
        pageName: String,
        lakes: Array,
        cartCount: Number
    },
    data() {
        return {
            showMenu: false,
        };
    },
    computed: {
        menu() {
            return mainMenu.filter(item =>
                item.routeName !== 'products.list' || this.$page.props.hasProducts
            )
        }
    },
    methods: {
        toggleNav() {
            this.showMenu = !this.showMenu;
        },
    },
};
</script>
